import { useCallback } from 'react';
import { RadioProps } from 'tea-component';
import { CheckboxChangeEventTarget } from '../components/CheckboxExclusiveAli';

export function useRadio(props: Partial<RadioProps> & CheckboxChangeEventTarget) {
  const { checked, readOnly, disabled, onChange, value, name, className, ...htmlProps } = props;

  const handleChange = useCallback(
    (event) => {
      if (readOnly || disabled) {
        event.preventDefault();
        return;
      }
      onChange?.(event);
    },
    [disabled, readOnly, onChange],
  );

  const getInputProps = useCallback(
    (props, ref = null) => {
      return {
        type: 'radio',
        name,
        value,
        checked,
        onChange: handleChange,
        onClick: (e: React.MouseEvent<HTMLInputElement>) => {
          e.stopPropagation();
        },
        ref,
      };
    },
    [name, value, handleChange, checked],
  );

  const getRootProps = () => {
    return {
      ...htmlProps,
      disabled,
    };
  };

  return {
    getInputProps,
    getRootProps,
  };
}
